import { render } from "./table.vue?vue&type=template&id=18444304"
import script from "./table.vue?vue&type=script&lang=js"
export * from "./table.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/components/table.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "18444304"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('18444304', __exports__)) {
    console.log('reload')
    api.reload('18444304', __exports__)
  }
  
  module.hot.accept("./table.vue?vue&type=template&id=18444304", () => {
    console.log('re-render')
    api.rerender('18444304', render)
  })

}


export default __exports__